import { render, staticRenderFns } from "./ThirdPartyWidget.vue?vue&type=template&id=1ab285ae&scoped=true"
import script from "./ThirdPartyWidget.vue?vue&type=script&lang=js"
export * from "./ThirdPartyWidget.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyWidget.vue?vue&type=style&index=0&id=1ab285ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab285ae",
  null
  
)

export default component.exports